import * as React from "react"
import { cn } from "../../lib/utils"

// Un état se dit par un point + un libellé, jamais par un aplat de couleur :
// l'aplat crie, et quand tout crie plus rien ne se lit (charte, 2026-09-23).
export type StatusTone = "success" | "warning" | "destructive" | "info" | "neutral"

const DOT: Record<StatusTone, string> = {
  success: "bg-success",
  warning: "bg-warning",
  destructive: "bg-destructive",
  info: "bg-info",
  neutral: "bg-muted-foreground/60",
}

interface StatusDotProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone: StatusTone
  label?: React.ReactNode
}

function StatusDot({ tone, label, className, ...props }: StatusDotProps) {
  return (
    <span className={cn("inline-flex items-center gap-2 whitespace-nowrap", className)} {...props}>
      <span aria-hidden className={cn("h-1.5 w-1.5 shrink-0 rounded-full", DOT[tone])} />
      {label}
    </span>
  )
}

export { StatusDot }
